import { TermsListSpace } from 'src/types/api'

export const telecomConverter: Record<string, TermsListSpace.TermsTypeOption> = {
  '0': 'SKTTerms',
  '1': 'KTTerms',
  '2': 'LGUPTerms',
}

export const otpCertDefaultValues = {
  TranID: '',
  PNumber: '',
  ApprovalNumber: '',
}

export const termsDefaultValues = {
  PrivacyConsent: false,
  Marketing: false,
  Insurance: false,
  SKTPrivacy: false,
  KTPrivacy: false,
  LGUPPrivacy: false,
  Service: false,
  PrivacyThirdParty: false,
  allTerms: false,
  KTMVNO: false,
}
